// ─────────────────────────────────────────────────────────────────────────────
//  icons/Icons.jsx
//  All SVG icon definitions for Challan Settlement section headers.
//  Strokes use currentColor so they pick up the theme colour from SectionCard's
//  icon-wrap background (see sectionThemes in styles).
// ─────────────────────────────────────────────────────────────────────────────

import { greenShade, white } from "../../../config/ColorObj";
import { colors } from "../styles/ChallanSettlementStyles";

const iconStyle = { color: colors.white };

export const Icons = {
    doc: (
        <svg
            width="15" height="15" viewBox="0 0 14 14"
            fill="none" stroke="currentColor" strokeWidth="1.7"
            strokeLinecap="round" style={iconStyle}
        >
            <rect x="1" y="2" width="12" height="10" rx="2" />
            <line x1="4" y1="6" x2="10" y2="6" />
            <line x1="4" y1="9" x2="7" y2="9" />
        </svg>
    ),

    stock: (
        <svg
            width="15" height="15" viewBox="0 0 14 14"
            fill="none" stroke="currentColor" strokeWidth="1.7"
            strokeLinecap="round" style={iconStyle}
        >
            <rect x="1" y="1" width="12" height="12" rx="2" />
            <line x1="4" y1="5" x2="10" y2="5" />
            <line x1="4" y1="8" x2="10" y2="8" />
        </svg>
    ),

    payment: (
        <svg
            width="15" height="15" viewBox="0 0 14 14"
            fill="none" stroke="currentColor" strokeWidth="1.7"
            strokeLinecap="round" style={iconStyle}
        >
            <rect x="2" y="4" width="10" height="8" rx="1.5" />
            <path d="M5 4V3a2 2 0 0 1 4 0v1" />
        </svg>
    ),

    dues: (
        <svg
            width="15" height="15" viewBox="0 0 14 14"
            fill="none" stroke="currentColor" strokeWidth="1.7"
            strokeLinecap="round" style={iconStyle}
        >
            <path d="M2 12V5l5-3 5 3v7" />
            <rect x="5" y="8" width="4" height="4" />
        </svg>
    ),

    damage: (
        <svg
            width="15" height="15" viewBox="0 0 14 14"
            fill="none" stroke="currentColor" strokeWidth="1.7"
            strokeLinecap="round" style={iconStyle}
        >
            <circle cx="7" cy="7" r="5" />
            <line x1="7" y1="4.5" x2="7" y2="7" />
            <circle cx="7" cy="9.2" r=".7" fill="currentColor" stroke="none" />
        </svg>
    ),

    signoff: (
        <svg
            width="15" height="15" viewBox="0 0 14 14"
            fill="none" stroke="currentColor" strokeWidth="1.9"
            strokeLinecap="round" strokeLinejoin="round" style={iconStyle}
        >
            <polyline points="2,7 5,10 12,3" />
        </svg>
    ),
};
export const BigCheckIcon = () => (
    <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke={white}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export const CloseIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        aria-hidden="true"
    >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

export const ShieldIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
    >
        {/* Shield */}
        <path
            d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {/* Filled check */}
        <path
            d="M8.5 12.5l2.3 2.3 4.7-4.7"
            stroke={white}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CheckCircleIcon = ({ size = 16 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
);

export const FilledTick = ({ size = 17, color = greenShade }) => (
    <svg width={size} height={size} viewBox="0 0 24 24">
        <path
            d="M5 13.5L10 18L20 7.5"
            fill="none"
            stroke={color}
            strokeWidth="3.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const WarnIcon = ({ size = 16 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
);

export const ErrorIcon = ({ size = 16 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
);

export const SpinnerIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        aria-hidden="true"
        style={{ animation: "v-spin 0.85s linear infinite", display: "block" }}
    >
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
);

export const SaveIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

export const ArrowLeftIcon = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
    </svg>
);